import Icon from '../components/Icon.vue'

Icon.register({
  'horse-head': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M509.8 332.5L439.9 168.2C425 127 389.5 97.2 346.9 89 364.9 78.4 393.2 53.1 381.1 6.7 379.8 1.7 374-1.2 369.1 0.6L166.9 76.3C35.9 123.4 0 238.9 0 398.8V480C0 497.7 14.3 512 32 512H268.2C292 512 307.5 487 296.8 465.7L256 384V383.3C210.4 379.8 171.4 352.6 151.7 313.7 150.1 310.6 150.8 306.8 153.3 304.4L165.4 292.3C169.3 288.4 176 289.6 178.3 294.7 193.1 328.4 226.5 352.1 265.7 352.1 282.9 352.1 298.7 347 312.5 338.9L358.5 402.8C364.5 411.2 374.2 416.1 384.5 416.1H434.8C443.3 416.1 451.4 412.7 457.4 406.7L502.7 366.9C511.6 357.8 514.4 344.3 509.8 332.5zM328 224C314.7 224 304 213.3 304 200S314.7 176 328 176 352 186.7 352 200 341.3 224 328 224z'
      }
    ]
  }
})
